const colors = {
  // custom color added for filter sidebar
  'dark blue': '#000080',
  pink: '#FFC0CB',
  brown: '#964B00',
  'dark green': '#006400',
  'navy blue': '#000080',
  'light blue': '#cfecf7',
  green: '#71B58E',
  // general color palatte
  brand: {
    primary: {
      DEFAULT: '#A71C29',
      50: '#FFFAFA', // Lightest shade
      100: '#F4B3B7',
      200: '#F09C9F',
      300: '#EC7E7E',
      400: '#E65F5F',
      500: '#A71C29', // Base color
      600: '#A01824',
      700: '#9B1621',
      800: '#8B121D',
      900: '#7C0E1A', // Darkest shade
      shade: '#A71C291A',
      hover: '#9B1621',
    },
    secondary: {
      DEFAULT: '#FEA01A',
      50: '#fff3d1',
      100: '#ffe2a3',
      200: '#ffd073',
      300: '#ffbd43',
      400: '#ffab1a',
      500: '#fea01a', // Base color
      600: '#FEA01A', //used for color scheme
      700: '#b97512',
      800: '#8d590d',
      900: '#653e08',
    },
  },
  text: {
    primary: '#090F1A',
    secondary: '#475467',
    disable: '#94A3B8',
    white: '#FFFFFF',
    coupon: '#864F0B',
  },
  background: {
    primary: '#FCFCFD',
    secondary: '#F9FAFB',
    tertiary: '#F2F4F7',
    white: '#FFFFFF',
    page: '#D0D5DD',
  },
  border: {
    default: '#D0D5DD',
    default60: '#D0D5DD99',
    active: '#101828',
    error: '#F04438',
    hover: '#475467',
    light: '#E4E7EC', // Lighter shade
    dark: '#B0B5BD', // Darker shade
  },
  status: {
    success: '#27AE60',
    error: '#F04438',
    warning: '#F2994A',
  },
  button: {
    disable: '#E1E6EC',
  },
  card: {
    secondary: '#F2F4F7AD',
  },
};

export { colors };
